import type { Metadata, Viewport } from 'next'
import { Montserrat } from 'next/font/google'
import './globals.css'

const montserrat = Montserrat({ 
  subsets: ["latin", "latin-ext"],
  variable: '--font-montserrat',
})

export const dynamic = 'error'

export const metadata: Metadata = {
  title: 'ServicePro - Wkrótce Start',
  description: 'Wkrótce uruchomimy możliwość zakupu reklamy online. Pracujemy nad platformą, dzięki której szybko i wygodnie zamówisz reklamę oraz promocję swojej oferty.',
  generator: 'v0.app',
  icons: {
    icon: '/logo.png',
    apple: '/logo.png',
  },
}

export const viewport: Viewport = {
  themeColor: '#009DE1',
}

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode
}>) {
  return (
    <html lang="pl">
      <body className={`${montserrat.variable} font-sans antialiased`}>
        {children}
      </body>
    </html>
  )
}
